/** Per-domain (journal, account, third party) review state of the mappings the user confirms. */
export enum FecMappingReviewStatus {
  Confirmed = 'confirmed',
  InReview = 'in_review',
  Pending = 'pending',
}
